export function authorization(signedInstance) {
    return { authorization: signedInstance };
}
//# sourceMappingURL=authorization.js.map